import { Epic, ofType } from 'redux-observable';
import { forkJoin, of } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

import { FILE_PARTS_UPLOAD_REQUEST } from '../../../actions/types';
import { filePartsUploadAction } from '../../../actions';
import { ETagsList } from '@amzn/coral_com-amazon-transreportscenterservice';

export const filePartsUploadEpic: Epic = (action$, state$, { api }) =>
  action$.pipe(
    ofType(FILE_PARTS_UPLOAD_REQUEST),
    mergeMap(({ payload }) => {
      const { partUploadRequests, key } = payload;

      // forkJoin works like Promise.all()
      return forkJoin(partUploadRequests).pipe(
        mergeMap((response) => {
          if (response.includes(false)) {
            return of(filePartsUploadAction.failure({ key }));
          }

          const eTags: ETagsList = [];

          response.forEach((res) => {
            eTags.push(res.xhr.getResponseHeader('ETag')?.replaceAll('"', ''));
          });

          return of(filePartsUploadAction.success({ eTags, key }));
        })
      );
    })
  );

export default filePartsUploadEpic;
